import { ENDPOINTS } from '../../network/endpoints';

/** @implements {import('../../../contracts/IConversationsRepository').IConversationsRepository} */
export class ConversationsRepository {
  /** @param {import('../../../contracts/IHttpClient').IHttpClient} client */
  constructor(client) {
    this.client = client;
  }

  async getConversations(options = {}) {
    const response = await this.client.get(ENDPOINTS.CONVERSATIONS.BASE, {
      params: options,
    });
    return response.conversations;
  }

  async getConversationById(conversationId) {
    return this.client.get(ENDPOINTS.CONVERSATIONS.BY_ID(conversationId));
  }

  async deleteConversation(conversationId) {
    return this.client.delete(ENDPOINTS.CONVERSATIONS.BY_ID(conversationId));
  }

  async getConversationAudio(conversationId) {
    return this.client.getAudio(ENDPOINTS.CONVERSATIONS.AUDIO(conversationId));
  }

  async getConversationToken(agentId) {
    return this.client.get(ENDPOINTS.CONVERSATIONS.TOKEN, {
      params: { agent_id: agentId },
    });
  }

  async getSignedUrl(agentId) {
    return this.client.get(ENDPOINTS.CONVERSATIONS.SIGNED_URL, {
      params: { agent_id: agentId },
    });
  }
}
